import { useState } from "react";
import { ConfirmationModal } from "../../elements/ConfirmationModal";
import { LoadSavedViewModal } from "./LoadSavedViewModal";
import { SaveViewModal } from "./SaveViewModal";
import { UnsavedViewChangesModal } from "./UnsavedViewChangesModal";
import { SavedViewsDialogsProps } from "./SavedViewsDialogs.types";

/** The saved view dialogs, and the question about unsaved changes when the page is left. */
export function SavedViewsDialogs({
  search,
  savedViews,
  allowedEntityTypes,
  dialog,
  onClose,
}: SavedViewsDialogsProps) {
  const { view, canManage, blocker } = savedViews;
  const [saveCopy, setSaveCopy] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const saveAndContinue = async () => {
    setIsSubmitting(true);

    if (await savedViews.update()) {
      blocker.proceed?.();
    }

    setIsSubmitting(false);
  };

  const update = async () => {
    setIsSubmitting(true);
    await savedViews.update();
    setIsSubmitting(false);
    onClose();
  };

  return (
    <>
      {dialog === "load" && (
        <LoadSavedViewModal
          entityName={search.query.entityName}
          allowedEntityTypes={allowedEntityTypes}
          canManage={canManage}
          onLoad={savedViews.load}
          onClose={onClose}
        />
      )}
      {dialog === "saveAs" && <SaveViewModal onSave={savedViews.saveAs} onClose={onClose} />}
      {dialog === "update" && view && (
        <ConfirmationModal
          modalTitle="Update"
          isSubmitting={isSubmitting}
          onClose={onClose}
          onConfirm={update}
        >
          Are you sure you want to update {view.name}?
        </ConfirmationModal>
      )}
      {blocker.state === "blocked" &&
        (saveCopy ? (
          <SaveViewModal
            onSave={async (name) => {
              const saved = await savedViews.saveAs(name);

              if (saved) {
                blocker.proceed?.();
              }

              return saved;
            }}
            onClose={() => setSaveCopy(false)}
          />
        ) : (
          <UnsavedViewChangesModal
            isSubmitting={isSubmitting}
            onCancel={() => blocker.reset?.()}
            onContinueWithoutSaving={() => blocker.proceed?.()}
            onSaveAndContinue={saveAndContinue}
            onSaveAsNewView={() => setSaveCopy(true)}
          />
        ))}
    </>
  );
}
